// const API_VERSION = "1.0.0";

export const SITE_NAME = "Rain Forest";
export const CURRENCY = "৳";

// const ROOT_URL = "http://46.28.44.148:8000";
const ROOT_URL = "https://api.hfforu.com";
// const ROOT_URL = "http://46.28.44.148:8000";
// const ROOT_URL = "http://localhost:8010";
// const ROOT_URL = "http://192.168.1.120:8000";

export const IMAGE_URL = `${ROOT_URL}/files`;
export const FILE_URL = `${ROOT_URL}/files`;
// const ROOT_URL = "http://192.168.0.111:8000";
// export const IMAGE_URL = "http://192.168.0.111:8000";
// export const FILE_URL = "http://192.168.0.111:8000";

const API_URL = `${ROOT_URL}`;

// auth
export const LOGIN_URL = `${API_URL}/login`;
export const REFRESH_TOKEN = `${API_URL}/login/refresh-token`;

// user
export const GET_ALL_USER = `${API_URL}/users`;
export const GET_USER_PROFILE = `${API_URL}/profile`;
export const GET_USER_BY_ID = `${API_URL}/users/id`;
export const CREATE_USER_URL = `${API_URL}/users/create`;
export const UPDATE_USER_URL = `${API_URL}/users/update`;
export const CHANGE_PASSWORD_URL = `${API_URL}/users/change-user-password`;
export const DELETE_USER_URL = `${API_URL}/users/delete`;
export const UPLOAD_PROFILE_IMAGE = `${API_URL}/upload/profile-image`;
export const UPLOAD_STORE_PROFILE_IMAGE = `${API_URL}/upload/profile-image`;
export const UPLOAD_STORE_LOGO_IMAGE = `${API_URL}/upload/profile-image`;

// customer
export const GET_ALL_CUSTOMERS = `${API_URL}/customers`;
export const GET_CUSTOMER_BY_ID = `${API_URL}/customers/id`;
export const CREATE_CUSTOMER_URL = `${API_URL}/customers/create`;
export const UPDATE_CUSTOMER_URL = `${API_URL}/customers/update`;
export const DELETE_CUSTOMER_URL = `${API_URL}/customers/delete`;

// team members
export const GET_ALL_TEAM_MEMBERS = `${API_URL}/teamMember`;
export const GET_TEAM_MEMBER_BY_ID = `${API_URL}/teamMember/id`;
export const CREATE_TEAM_MEMBER_URL = `${API_URL}/teamMember/create`;
export const UPDATE_TEAM_MEMBER_URL = `${API_URL}/teamMember/update`;
export const DELETE_TEAM_MEMBER_URL = `${API_URL}/teamMember/delete`;
export const UPLOAD_TEAM_MEMBER_IMAGE_URL = `${API_URL}/suite-image`;
// suit
export const GET_ALL_SUITS = `${API_URL}/suite`;
export const GET_SUIT_BY_ID = `${API_URL}/suite/id`;
export const CREATE_SUIT_URL = `${API_URL}/suite/create`;
export const UPDATE_SUIT_URL = `${API_URL}/suite/update`;
export const DELETE_SUIT_URL = `${API_URL}/suite/delete`;
export const UPLOAD_SUIT_IMAGE_URL = `${API_URL}/suite-image`;

// banner
export const GET_ALL_BANNERS = `${API_URL}/banners`;
export const GET_BANNER_BY_ID = `${API_URL}/banners/id`;
export const CREATE_BANNER_URL = `${API_URL}/banners/create`;
export const UPDATE_BANNER_URL = `${API_URL}/banners/update`;
export const DELETE_BANNER_URL = `${API_URL}/banners/delete`;

// tributes
export const GET_ALL_TRIBUTES = `${API_URL}/tributes`;
export const GET_TRIBUTE_BY_ID = `${API_URL}/tributes/id`;
export const CREATE_TRIBUTE_URL = `${API_URL}/tributes/create`;
export const UPDATE_TRIBUTE_URL = `${API_URL}/tributes/update`;
export const DELETE_TRIBUTE_URL = `${API_URL}/tributes/delete`;

// activity
export const GET_ALL_ACTIVITIES = `${API_URL}/activities`;
export const GET_ACTIVITY_BY_ID = `${API_URL}/activities/id`;
export const CREATE_ACTIVITY_URL = `${API_URL}/activities/create`;
export const UPDATE_ACTIVITY_URL = `${API_URL}/activities/update`;
export const DELETE_ACTIVITY_URL = `${API_URL}/activities/delete`;

// Complimentary
export const GET_ALL_COMPLIMENTARIES = `${API_URL}/complimentaries`;
export const GET_COMPLIMENTARY_BY_ID = `${API_URL}/complimentaries/id`;
export const CREATE_COMPLIMENTARY_URL = `${API_URL}/complimentaries/create`;
export const UPDATE_COMPLIMENTARY_URL = `${API_URL}/complimentaries/update`;
export const DELETE_COMPLIMENTARY_URL = `${API_URL}/complimentaries/delete`;

// Accommodation
export const GET_ALL_ACCOMMODATION = `${API_URL}/accommodation`;
export const GET_ACCOMMODATION_BY_ID = `${API_URL}/accommodation/id`;
export const CREATE_ACCOMMODATION_URL = `${API_URL}/accommodation/create`;
export const UPDATE_ACCOMMODATION_URL = `${API_URL}/accommodation/update`;
export const DELETE_ACCOMMODATION_URL = `${API_URL}/accommodation/delete`;

// booking
export const GET_ALL_BOOKING = `${API_URL}/booking`;
export const GET_BOOKING_BY_ID = `${API_URL}/booking/id`;
export const UPDATE_BOOKING_URL = `${API_URL}/booking/update`;
export const DELETE_BOOKING_URL = `${API_URL}/booking/delete`;

// stores
export const GET_ALL_STORES = `${API_URL}/stores`;
export const GET_STORE_BY_ID = `${API_URL}/stores/id`;
export const CREATE_STORE_URL = `${API_URL}/stores/create`;
export const UPDATE_STORE_URL = `${API_URL}/stores/update`;
export const DELETE_STORE_URL = `${API_URL}/stores/delete`;

// static page
export const GET_ALL_STATIC_PAGES = `${API_URL}/static-page`;
export const GET_STATIC_PAGE_BY_ID = `${API_URL}/static-page/id`;
export const CREATE_STATIC_PAGE_URL = `${API_URL}/static-page/create`;
export const UPDATE_STATIC_PAGE_URL = `${API_URL}/static-page/update`;
export const DELETE_STATIC_PAGE_URL = `${API_URL}/static-page/delete`;
export const UPLOAD_STATIC_PAGE_IMAGE_URL = `${API_URL}/suite-image`;

// site config
export const GET_ALL_SITE_CONFIGS = `${API_URL}/site-config`;
export const GET_SITE_CONFIG_BY_ID = `${API_URL}/site-config/id`;
export const CREATE_SITE_CONFIG_URL = `${API_URL}/site-config/create`;
export const UPDATE_SITE_CONFIG_URL = `${API_URL}/site-config/update`;
export const DELETE_SITE_CONFIG_URL = `${API_URL}/site-config/delete`;
export const UPLOAD_SITE_CONFIG_LOGO_URL = `${API_URL}/suite-image`;

// home content
export const GET_ALL_HOME_CONTENTS = `${API_URL}/home-content`;
export const GET_HOME_CONTENT_BY_ID = `${API_URL}/home-content/id`;
export const CREATE_HOME_CONTENT_URL = `${API_URL}/home-content/create`;
export const UPDATE_HOME_CONTENT_URL = `${API_URL}/home-content/update`;
export const DELETE_HOME_CONTENT_URL = `${API_URL}/home-content/delete`;
export const UPLOAD_HOME_CONTENT_IMAGE_URL = `${API_URL}/suite-image`;

// about content
export const GET_ALL_ABOUT_CONTENTS = `${API_URL}/about-content`;
export const GET_ABOUT_CONTENT_BY_ID = `${API_URL}/about-content/id`;
export const CREATE_ABOUT_CONTENT_URL = `${API_URL}/about-content/create`;
export const UPDATE_ABOUT_CONTENT_URL = `${API_URL}/about-content/update`;
export const DELETE_ABOUT_CONTENT_URL = `${API_URL}/about-content/delete`;
export const UPLOAD_ABOUT_CONTENT_IMAGE_URL = `${API_URL}/suite-image`;

// promotion
export const GET_ALL_PROMOTIONS = `${API_URL}/promotion`;
export const GET_PROMOTION_BY_ID = `${API_URL}/promotion/id`;
export const CREATE_PROMOTION_URL = `${API_URL}/promotion/create`;
export const UPDATE_PROMOTION_URL = `${API_URL}/promotion/update`;
export const DELETE_PROMOTION_URL = `${API_URL}/promotion/delete`;
export const UPLOAD_PROMOTION_IMAGE_URL = `${API_URL}/suite-image`;

// Blogs
export const GET_ALL_BLOGS = `${API_URL}/blogs`;
export const GET_BLOG_BY_ID = `${API_URL}/blogs/id`;
export const CREATE_BLOG_URL = `${API_URL}/blogs/create`;
export const UPDATE_BLOG_URL = `${API_URL}/blogs/update`;
export const DELETE_BLOG_URL = `${API_URL}/blogs/delete`;
export const UPLOAD_BLOG_IMAGE_URL = `${API_URL}/suite-image`;

export const GET_ALL_CUSTOMER_FEEDBACK = `${API_URL}/customer-feedback`;

// package
export const GET_ALL_PACKAGES = `${API_URL}/package`;
export const GET_PACKAGE_BY_ID = `${API_URL}/package/id`;
export const CREATE_PACKAGE_URL = `${API_URL}/package/create`;
export const UPDATE_PACKAGE_URL = `${API_URL}/package/update`;
export const DELETE_PACKAGE_URL = `${API_URL}/package/delete`;
export const UPLOAD_PACKAGE_IMAGE_URL = `${API_URL}/suite-image`;
export const UPLOAD_IMAGE_URL = `${API_URL}/suite-image`;

// category

export const GET_ALL_CATEGORY = `${API_URL}/category`;
export const GET_CATEGORY_BY_ID = `${API_URL}/category/id`;
export const CREATE_CATEGORY_URL = `${API_URL}/category/create`;
export const UPDATE_CATEGORY_URL = `${API_URL}/category/update`;
export const DELETE_CATEGORY_URL = `${API_URL}/category/delete`;
// factory

export const GET_ALL_FACTORY = `${API_URL}/factory`;
export const GET_FACTORY_BY_ID = `${API_URL}/factory/id`;
export const CREATE_FACTORY_URL = `${API_URL}/factory/create`;
export const UPDATE_FACTORY_URL = `${API_URL}/factory/update`;
export const DELETE_FACTORY_URL = `${API_URL}/factory/delete`;
// product capacity
export const GET_ALL_PRODUCT_CAPACITY = `${API_URL}/product-capacity`;
export const GET_PRODUCT_CAPACITY_BY_ID = `${API_URL}/product-capacity/id`;
export const CREATE_PRODUCT_CAPACITY_URL = `${API_URL}/product-capacity/create`;
export const UPDATE_PRODUCT_CAPACITY_URL = `${API_URL}/product-capacity/update`;
export const DELETE_PRODUCT_CAPACITY_URL = `${API_URL}/product-capacity/delete`;

// products
export const GET_ALL_PRODUCTS = `${API_URL}/products`;
export const GET_PRODUCT_BY_ID = `${API_URL}/products/id`;
export const CREATE_PRODUCT_URL = `${API_URL}/products/create`;
export const UPDATE_PRODUCT_URL = `${API_URL}/products/update`;
export const DELETE_PRODUCT_URL = `${API_URL}/products/delete`;

// testimonials
export const GET_ALL_TESTIMONIALS = `${API_URL}/testimonials`;
export const GET_TESTIMONIAL_BY_ID = `${API_URL}/testimonials/id`;
export const CREATE_TESTIMONIAL_URL = `${API_URL}/testimonials/create`;
export const UPDATE_TESTIMONIAL_URL = `${API_URL}/testimonials/update`;
export const DELETE_TESTIMONIAL_URL = `${API_URL}/testimonials/delete`;

// buyer
export const GET_ALL_BUYERS = `${API_URL}/buyers`;
export const GET_BUYER_BY_ID = `${API_URL}/buyers/id`;
export const CREATE_BUYER_URL = `${API_URL}/buyers/create`;
export const UPDATE_BUYER_URL = `${API_URL}/buyers/update`;
export const DELETE_BUYER_URL = `${API_URL}/buyers/delete`;

// factory options (search filter dropdown data)
export const GET_ALL_FACTORY_OPTIONS = `${API_URL}/factory-options`;
export const GET_FACTORY_OPTIONS_BY_ID = `${API_URL}/factory-options/id`;
export const CREATE_FACTORY_OPTIONS_URL = `${API_URL}/factory-options/create`;
export const UPDATE_FACTORY_OPTIONS_URL = `${API_URL}/factory-options/update`;
export const DELETE_FACTORY_OPTIONS_URL = `${API_URL}/factory-options/delete`;
export const ADD_FACTORY_OPTION_ITEM_URL = (groupId) =>
    `${API_URL}/factory-options/${groupId}/options`;
export const UPDATE_FACTORY_OPTION_ITEM_URL = (groupId, optionId) =>
    `${API_URL}/factory-options/${groupId}/options/${optionId}`;
export const DELETE_FACTORY_OPTION_ITEM_URL = (groupId, optionId) =>
    `${API_URL}/factory-options/${groupId}/options/${optionId}`;

// buying partners
export const GET_ALL_BUYING_PARTNERS = `${API_URL}/buying-partners`;
export const GET_BUYING_PARTNER_BY_ID = `${API_URL}/buying-partners/id`;
export const CREATE_BUYING_PARTNER_URL = `${API_URL}/buying-partners/create`;
export const UPDATE_BUYING_PARTNER_URL = `${API_URL}/buying-partners/update`;
export const DELETE_BUYING_PARTNER_URL = `${API_URL}/buying-partners/delete`;
export const ADD_BUYING_PARTNER_ITEM_URL = (groupId) =>
    `${API_URL}/buying-partners/${groupId}/partners`;
export const UPDATE_BUYING_PARTNER_ITEM_URL = (groupId, partnerId) =>
    `${API_URL}/buying-partners/${groupId}/partners/${partnerId}`;
export const DELETE_BUYING_PARTNER_ITEM_URL = (groupId, partnerId) =>
    `${API_URL}/buying-partners/${groupId}/partners/${partnerId}`;

// careers
export const GET_ALL_CAREERS = `${API_URL}/careers`;
export const GET_CAREER_BY_ID = `${API_URL}/careers/id`;
export const CREATE_CAREER_URL = `${API_URL}/careers/create`;
export const UPDATE_CAREER_URL = `${API_URL}/careers/update`;
export const DELETE_CAREER_URL = `${API_URL}/careers/delete`;

// sustainability
export const GET_ALL_SUSTAINABILITY = `${API_URL}/sustainability`;
export const GET_SUSTAINABILITY_BY_ID = `${API_URL}/sustainability/id`;
export const CREATE_SUSTAINABILITY_URL = `${API_URL}/sustainability/create`;
export const UPDATE_SUSTAINABILITY_URL = `${API_URL}/sustainability/update`;
export const DELETE_SUSTAINABILITY_URL = `${API_URL}/sustainability/delete`;

// factory certifications
export const GET_ALL_FACTORY_CERTIFICATIONS = `${API_URL}/factory-certifications`;
export const GET_FACTORY_CERTIFICATION_BY_ID = `${API_URL}/factory-certifications/id`;
export const CREATE_FACTORY_CERTIFICATION_URL = `${API_URL}/factory-certifications/create`;
export const UPDATE_FACTORY_CERTIFICATION_URL = `${API_URL}/factory-certifications/update`;
export const DELETE_FACTORY_CERTIFICATION_URL = `${API_URL}/factory-certifications/delete`;
export const ADD_CERT_ITEM_URL = (docId) =>
    `${API_URL}/factory-certifications/${docId}/certs`;
export const UPDATE_CERT_ITEM_URL = (docId, certId) =>
    `${API_URL}/factory-certifications/${docId}/certs/${certId}`;
export const DELETE_CERT_ITEM_URL = (docId, certId) =>
    `${API_URL}/factory-certifications/${docId}/certs/${certId}`;

// CONSTANT_EXPORTS_AREA

export const ACCESS_TOKEN = "u-pos-access-token";
export const STORE_ID = "u-pos-store-id";
export const PROFILE = "u-pos-profile";

export const ORDER_STATE_COLOR = {
    INITIATED: "",
    SUPPLIER_ACCEPTED: "cyan",
    DELIVERY_MAN_PICKED: "blue",
    COMPLETED: "green",
    CANCELED: "red"
};

export const GENDER_COLOR = {
    MALE: "blue",
    FEMALE: "green",
    OTHERS: "purple"
};
export const COMPANY = {
    name: "URELAA",
    address: "Dhaka Division, Bangladesh"
};

export const BACK_BUTTON_COLOR = "#3390FF";
// end
